import store from '../../../vuex/store.js';
let open_arr = []
let close_arr = []
function open_item(open_arr){
    open_arr.map((item)=>{
        store.commit("temp",{
            key: item,
            value: true,
        })
    })
}
function close_item(close_arr){
    close_arr.map((item)=>{
        store.commit("temp",{
            key: item,
            value: false,
        })
    })
}
export function xuexi_qsxueli(){
    // ********* 登录页 START *********/
    // store.commit("temp",{
    //     key: "login.components",
    //     value: "qsxueli",
    // })
    // ********* 登录页 END *********/
}
export function dyy_xuexi_qsxueli(){
    // ********* 顶部 START *********/
    close_arr.push("head.menu.pIteamGroup")
    close_arr.push("head.menu.exam_list")
    close_arr.push("head.menu.chengji")
    close_arr.push("head.menu.biji")
    close_arr.push("head.menu.tongji")
    close_arr.push("head.menu.problem")
    close_arr.push("head.menu.material")
    close_arr.push("head.menu.own_examination")
    close_arr.push("head.wechatProgram")
    close_arr.push("head.new_message")
    close_arr.push("head.rangeHeader.logo")

    open_arr.push("head.menu.course_selection")
    open_arr.push("head.menu.certificate_download")
    open_arr.push("head.menu.announcement_list")
    // ********* 顶部 END *********/

    // ********* 登录页 START *********/
    store.commit("temp",{
        key: "login.components",
        value: "dyy",
    })
    close_arr.push("login.login_port")
    close_arr.push("login.login.image_captcha")
    close_arr.push("login.login.captcha")
    close_arr.push("login.qrLogin.image_captcha")
    close_arr.push("login.qrLogin.captcha")
    // ********* 登录页 END *********/

    // ********* 课程详情页 START *********/
    close_arr.push("courseInfo.keMenu.biji")
    close_arr.push("courseInfo.keMenu.taolun")
    close_arr.push("courseInfo.keMenu.tiku")
    // ********* 课程详情页 END *********/

    // ********* 首页 START *********/
    close_arr.push("index.live_list")
    // ********* 首页 END *********/

    // ********* 个人中心页 START *********/
    close_arr.push("userCenter.index.attestation")
    close_arr.push("userCenter.index.purchased")
    // ********* 个人中心页 END *********/

    open_item( open_arr)
    close_item( close_arr)
}
export function en_degree_qsxueli(){
    // ********* 顶部 START *********/

    // 修改首页 及 顶部默认项
    store.commit("defaultIndex",'exam_list')
    store.commit("activeIndex", 'exam_list' )

    // close_arr.push("head.logo")
    close_arr.push("head.menu.index")
    close_arr.push("head.menu.pIteamGroup")
    close_arr.push("head.menu.chengji")
    close_arr.push("head.menu.biji")
    close_arr.push("head.menu.tongji")
    close_arr.push("head.menu.problem")
    close_arr.push("head.menu.material")
    close_arr.push("head.menu.own_examination")
    close_arr.push("head.menu.userIndex")
    close_arr.push("head.wechatProgram")
    close_arr.push("head.new_message")
    close_arr.push("head.rangeHeader.logo")

    open_arr.push("head.menu.exam_list")
    open_arr.push("head.menu.exam_uinfo")
    // ********* 顶部 END *********/

    // ********* 底部 START *********/
    close_arr.push("footer.show")
    // ********* 底部 END *********/

    // ********* 登录页 START *********/
    close_arr.push("login.login_port")
    close_arr.push("login.login.phone_login")
    close_arr.push("login.login.reset_pwd")
    // ********* 登录页 END *********/

    // ********* 我的考试列表 START *********/
    close_arr.push("course_info.exam_list.list.fraction")
    close_arr.push("course_info.exam_list.list.result")
    // ********* 我的考试列表 END *********/

    // ********* 考试页 START *********/
    close_arr.push("course_info.test.location.index")
    close_arr.push("course_info.test.open.up_img")
    close_arr.push("course_info.test.universal.open.up_img")
    close_arr.push("course_info.test.onblur")
    // ********* 考试页 END *********/

    open_item( open_arr)
    close_item( close_arr)
}
export default {
    xuexi_qsxueli,
    dyy_xuexi_qsxueli,
    en_degree_qsxueli,
}


// WEBPACK FOOTER //
// ./src/static/js/template/temp_change.js